import React, { useEffect, useState } from 'react';

interface TooltipProps extends React.HTMLAttributes<HTMLDivElement> {
  hoverRef: React.RefObject<HTMLElement>;
}

type TooltipPosition = {
  y: number;
  visible: boolean;
}

const Tooltip = ({ hoverRef, children }: TooltipProps) => {
  const [position, setPosition] = useState<TooltipPosition>({
    y: 0,
    visible: false,
  });

  useEffect(() => {
    const handleMouseMove = (event: MouseEvent) => {
      if (hoverRef.current) {
        let y = event.layerY + 20;
        setPosition({ y, visible: true });
      }
    };
    const handleMouseEnter = () => {
      setPosition(prevState => ({ ...prevState, visible: true }));
    };

    const handleMouseLeave = () => {
      setPosition(prevState => ({ ...prevState, visible: false }));
    };

    if (hoverRef.current) {
      hoverRef.current.addEventListener("mousemove", handleMouseMove);
      hoverRef.current.addEventListener("mouseenter", handleMouseEnter);
      hoverRef.current.addEventListener("mouseleave", handleMouseLeave);
    }

    return () => {
      if (hoverRef.current) {
        hoverRef.current.removeEventListener("mousemove", handleMouseMove);
        hoverRef.current.removeEventListener("mouseenter", handleMouseEnter);
        hoverRef.current.removeEventListener("mouseleave", handleMouseLeave);
      }
    };
  }, [hoverRef]);
  return (
    <div
      className="flex gap-2 text-sm absolute right-2 left-2 shadow-md bg-stone-50 border-2 border-blue-100 p-4 rounded-md"
      style={{
        visibility: position.visible ? 'visible' : 'hidden',
        top: position.y,
      }}
    >
      {children}
    </div>
  );
};

export default Tooltip;